export default {
  locale: 'no',
  Search: {
    Search: 'Søk',
    Loading: 'Lastar',
    Clear: 'Nullstill søk'
  },
  ArticleList: {
    ReadMore: 'Les meir',
    Loading: 'Lastar',
    NoResults: 'Fann ingen treff.',
    NoResultsTryChange: 'Freist å panorere i kartet eller vel andre kjeldar.'
  },
  ArticleWindow: {
    locale: 'nb-NO',
    OpenExternal: 'Opne kjeldeartikkel i nytt vindauge',
    Close: 'Steng',
    Loading: 'Lastar artikkel',
    LoadError: 'Kunne ikkje laste artikkel.'
  },
  ArticleComments: {
    locale: 'nb-NO',
    Comment: 'Skriv ein kommentar',
    DisplayName: 'Visingsnamn',
    Email: 'E-post (ikkje synleg)',
    Submit: 'Publiser',
    CouldNotPostComment: 'Ein feil oppstod.',
    Publishing: 'Publiserer',
    Hide: 'Gøym'
  },
  Comments: {
    locale: 'nb-NO',
    NoTitle: '(Uten tittel)',
    Previous: 'Forrige',
    Next: 'Neste',
    Page: 'Side',
    Of: 'av',
    Flag: 'Rapporter som upassande',
    Flagged: 'Rapportert'
  },
  SearchSource: {
    locale: 'nb-NO',
    showAllResults: 'Vis alle treff',
    goBack: 'Attende'
  }
};